import allProducts from "../api/allproducts";

// GET PRODUCTS FROM API
let allproduct = allProducts.getAllProducts();

// ACTION GET ALL PRODUCTS
export const getAllProducts = ({ commit }) => {
  commit("GET_ALL_PRODUCTS", allproduct);
};

// CHECKOUT
export const setCheckout = ({ commit }) => {
  commit("SET_CHECKOUT");
};

// ADD PRODUCTS TO CART
export const addProductToCart = ({ commit }, { product, quantity }) => {
  commit("ADD_TO_CART", { product, quantity });
};

// GET SEARCH RESULT
export const getSearchResult = ({ commit }, productSearch) => {
  commit("GET_SEARCH_RESULT", productSearch);
};

// REMOVE PRODUCTS TO CART
export const removeProductFromCart = ({ commit }, product) => {
  commit("REMOVE_PRODUCT_FROM_CART", product);
};

// CLEAR ALL PRODUCTS IN CART
export const clearCart = ({ commit }) => {
  commit("CLEAR_CART");
};

// SHOW SEARCH INPUT
export const showSearch = ({ commit }) => {
  commit("SHOW_SEARCH");
};

// HIDE SEARCH INPUT
export const hideSearch = ({ commit }) => {
  commit("HIDE_SEARCH");
};
